





/* Created- 25 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import { UserModel, throwException, AccountClient } from "../Generated/ParticaAPI";
import ParticaBaseView from "../Views/Base/ParticaBaseView.vue";
import axios from "axios";
import { getActionName, ParticaEvent } from "../Models/ParticaEvent";

@Component(
	{
		name: "ConfirmEmail",
		components: { ParticaError }
	})
export default class ConfirmEmail extends ParticaBaseView {
	private svc: AccountClient;
	private userid: string = "";
	private confirmcode: string = "";


	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.svc = new AccountClient();
		this.init();
	}

	private async init() {
		try {
			this.confirmcode = this.$route.query.code as string;
			this.userid = this.$route.query.id as string;
			await this.svc.confirmEmail(this.userid, this.confirmcode);
			this.navigate("/login", undefined);
		} catch (error) {
			this.ShowErrorDialog(error, "An error occured confirming your email. Try again.");
		}

	}
}
